export const LIMIT_MESSAGE = { 1: 1000, 2: 3000, 3: 5000 };
